import httpRequest from "utils/httpRequest";
const URL = "/api";

// Field === Site 같은 의미로 사용
// Frontend = Site
// Backend = Object 라고 부름

export const getDevicesInField = async (field_id) => {
  const requestBody = {
    field_id,
  };

  try {
    const response = await httpRequest("post", `${URL}/getDevicesInField`, requestBody);
    return response;
  } catch (error) {
    console.error(error);
  }
};

export const copyDeviceObjectList = async (data,field_id,group_id) => {
  const requestBody = {
    field_id,
    group_id,
    source_field_id: data.source_field_id,
    source_id: data.source_id,
    destination_id: data.destination_id,
    prefix: data.nm_prefix ?? "",
    suffix: data.nm_suffix ?? "",
    src_left_offset: data.src_left_offset,
    dest_left_offset: data.dest_left_offset,
    width: data.width,
  };

  try {
    const response = await httpRequest("post", `${URL}/copyDeviceObject`, requestBody);
    return response;
  } catch (error) {
    console.error(error);
  }
};

export const getObjList = async (e_line, cur_page, group_id, field_id) => {
  const requestBody = {
    e_line,
    cur_page,
    group_id,
    field_id,
  };
  try {
    const response = await httpRequest("post", `${URL}/objList`, requestBody);
    return response;
  } catch (error) {
    console.error(error);
  }
};

export const getObj = async (field_id, object_id) => {
  const requestBody = {
    field_id,
    object_id,
  };
  try {
    const response = await httpRequest("post", `${URL}/getObj`, requestBody);
    return response;
  } catch (error) {
    console.error(error);
  }
};

export const getSttus = async (fn_group_id, field_id) => {
  const requestBody = {
    fn_group_id,
    field_id,
  };
  try {
    const response = await httpRequest("post", `${URL}/getSttus`, requestBody);
    return response;
  } catch (error) {
    console.error(error);
  }
};

export const insertObj = async (objectList, imgyeList) => {
  let requestBody = { objList: objectList };

  if (imgyeList.length > 0) {
    requestBody = { ...requestBody, imgyeList };
  }
  try {
    const response = await httpRequest("post", `${URL}/insertObjList`, requestBody);
    return response;
  } catch (error) {
    console.error(error);
  }
};

export const updateObj = async (object_id, objectList, imgyeList,callLoc) => {
  let requestBody = {
    object_id,
    objList: objectList,
    callLocation: callLoc,
  };

  if (imgyeList?.length > 0) {
    requestBody = { ...requestBody, imgyeList };
  }

  try {
    const response = await httpRequest("post", `${URL}/updateObjList`, requestBody);
    return response;
  } catch (error) {
    console.error(error);
  }
};

/**
 *
 * User Info Delete API
 */
export const deleteObj = async (object_id) => {
  const requestBody = {
    object_id: object_id,
  };
  try {
    const response = await httpRequest("post", `${URL}/deleteObject`, requestBody);
    return response;
  } catch (error) {
    console.error(error);
  }
};

export const getObjMenu = async () => {
  const requestBody = {};
  try {
    const response = await httpRequest("post", `${URL}/getObjMenu`, requestBody);
    return response;
  } catch (error) {
    console.error(error);
  }
};

export const getFieldUser = async (fn_group_id) => {
  const requestBody = {
    fn_group_id,
  };
  try {
    const response = await httpRequest("post", `${URL}/popUsr3N`, requestBody);
    return response;
  } catch (error) {
    console.error(error);
  }
};

export const updateChannelControlValue = async (changedItem) => {
  try {
    const response = await fetch(`${URL}/updateChannelControlValue`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json; charset=UTF-8;",
      },
      body: JSON.stringify(changedItem),
    });

    const message = await response.text();

    return message;
  } catch (error) {
    console.error(error);
  }
};
